import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../config/supabase';
import './Sidebar.css';

const Sidebar = ({ setActiveTab, isOpen, onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isTransformationsOpen, setIsTransformationsOpen] = useState(true);
    const [isAnalyticsOpen, setIsAnalyticsOpen] = useState(true);
    const [isApiLogsOpen, setIsApiLogsOpen] = useState(false);
    const loggedInUser = localStorage.getItem('username') || 'User';
    const userInitials = loggedInUser.slice(0, 2).toUpperCase();

    const handleNavigation = (path, tab) => {
        setActiveTab(tab);
        navigate(path);
        if (window.innerWidth <= 768 && onClose) {
            onClose();
        }
    };

    const isActive = (path) => location.pathname === path;

    return (
        <>
            {/* Mobile Overlay */}
            <div
                className={`sidebar-overlay ${isOpen ? 'open' : ''}`}
                onClick={onClose}
            ></div>

            <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
                <div className="logo-section">
                    <a href="/" className="logo">
                        <div className="logo-icon">
                            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                {/* Titan Logo - Mountain/Peak design representing strength */}
                                <path d="M20 5L35 25L30 25L20 12L10 25L5 25L20 5Z" fill="url(#gradient1)" />
                                <path d="M20 15L28 25L12 25L20 15Z" fill="url(#gradient2)" />
                                <path d="M15 25L20 35L25 25H15Z" fill="url(#gradient3)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#6366f1" stopOpacity="1" />
                                        <stop offset="100%" stopColor="#8b5cf6" stopOpacity="1" />
                                    </linearGradient>
                                    <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#8b5cf6" stopOpacity="1" />
                                        <stop offset="100%" stopColor="#a855f7" stopOpacity="1" />
                                    </linearGradient>
                                    <linearGradient id="gradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#4f46e5" stopOpacity="1" />
                                        <stop offset="100%" stopColor="#6366f1" stopOpacity="1" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <span className="logo-text">TITAN</span>
                    </a>
                    {/* Mobile Close Button */}
                    <button className="mobile-close-btn" onClick={onClose}>
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>

                <nav className="nav-section">
                    <div className="nav-group">
                        <div className="nav-group-title">Analytics</div>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/dashboard') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/dashboard', 'dashboard');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
                                </svg>
                            </span>
                            <span>Overview</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/custom-analytics') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/custom-analytics', 'custom-analytics');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                                </svg>
                            </span>
                            <span>Custom Analytics</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/as2-metrics') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/as2-metrics', 'as2-metrics');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"></path>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"></path>
                                </svg>
                            </span>
                            <span>AS2 Metrics</span>
                        </a>
                    </div>

                    <div className="nav-group">
                        <div className="nav-group-title">Relay</div>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/relay/overview') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/relay/overview', 'relay-overview');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
                                </svg>
                            </span>
                            <span>Overview</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/transformations') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/transformations', 'transformations');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                                </svg>
                            </span>
                            <span>Transformations</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/transformations/api-integration') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/transformations/api-integration', 'api-integration');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                                </svg>
                            </span>
                            <span>API Proxy</span>
                        </a>
                    </div>

                    <div className="nav-group">
                        <div className="nav-group-title">Partner Connections</div>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/partners') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/partners', 'partners');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>
                                </svg>
                            </span>
                            <span>Address Book</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/as2-routing') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/as2-routing', 'as2-routing');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"></path>
                                </svg>
                            </span>
                            <span>AS2 Routing</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/as2-connectors') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/as2-connectors', 'as2-connectors');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"></path>
                                </svg>
                            </span>
                            <span>AS2 Connectors</span>
                        </a>
                    </div>

                    <div className="nav-group">
                        <div className="nav-group-title">Operations</div>
                        <a href="#" className="nav-item">
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                                </svg>
                            </span>
                            <span>Shipments</span>
                        </a>
                    </div>

                    <div className="nav-group">
                        <div className="nav-group-title">Monitoring</div>
                        <a href="#" className="nav-item">
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                                </svg>
                            </span>
                            <span>Alerts</span>
                            <span className="nav-badge">3</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/soap-history') || isActive('/logs') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                setIsApiLogsOpen(!isApiLogsOpen);
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                            </span>
                            <span>API Logs</span>
                            <span className="nav-expand" style={{ marginLeft: 'auto', transition: 'transform 0.2s', transform: isApiLogsOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </span>
                        </a>

                        {isApiLogsOpen && (
                            <div style={{ paddingLeft: '20px' }}>
                                <a
                                    href="#"
                                    className={`nav-item ${isActive('/soap-history') ? 'active' : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNavigation('/soap-history', 'soap-history');
                                    }}
                                    style={{ fontSize: '13px' }}
                                >
                                    <span className="nav-icon">
                                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                    </span>
                                    <span>History</span>
                                </a>
                                <a
                                    href="#"
                                    className={`nav-item ${isActive('/logs') ? 'active' : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNavigation('/logs', 'logs');
                                    }}
                                    style={{ fontSize: '13px' }}
                                >
                                    <span className="nav-icon">
                                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                                        </svg>
                                    </span>
                                    <span>Real-time</span>
                                </a>
                            </div>
                        )}
                        <a
                            href="#"
                            className={`nav-item ${isActive('/file-transmissions') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/file-transmissions', 'file-transmissions');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                                </svg>
                            </span>
                            <span>AS2 Logs</span>
                        </a>
                    </div>

                    <div className="nav-group">
                        <div className="nav-group-title">Tools</div>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/send-file') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/send-file', 'send-file');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"></path>
                                </svg>
                            </span>
                            <span>Send File</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/epcis-rules') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/epcis-rules', 'epcis-rules');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"></path>
                                </svg>
                            </span>
                            <span>EPCIS Rules</span>
                        </a>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/data-explorer') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/data-explorer', 'data-explorer');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                                </svg>
                            </span>
                            <span>Data Explorer</span>
                        </a>
                    </div>

                    <div className="nav-group">
                        <div className="nav-group-title">System</div>
                        <a
                            href="#"
                            className={`nav-item ${isActive('/settings') ? 'active' : ''}`}
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('/settings', 'settings');
                            }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                </svg>
                            </span>
                            <span>Settings</span>
                        </a>
                        <a
                            href="#"
                            className="nav-item"
                            onClick={async (e) => {
                                e.preventDefault();
                                await supabase.auth.signOut();
                                localStorage.removeItem('isAuthenticated');
                                localStorage.removeItem('username');
                                window.location.href = '/login';
                            }}
                            style={{ color: '#ef4444' }}
                        >
                            <span className="nav-icon">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
                                </svg>
                            </span>
                            <span>Logout</span>
                        </a>
                    </div>
                </nav>

                <div className="sidebar-footer">
                    <div className="user-section">
                        <div className="user-avatar">{userInitials}</div>
                        <div className="user-info">
                            <div className="user-name">{loggedInUser}</div>
                            <div className="user-role">Admin</div>
                        </div>
                        <span className="user-dropdown">▼</span>
                    </div>
                    <div className="sidebar-version">
                        v{__APP_VERSION__} · {__BUILD_SHA__}
                    </div>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
